<script>
  import {
    RIGHT_DISTRICT_POLICIES_TITLE,
    RIGHT_DISTRICT_INSTRUCTIONS,
    RIGHT_CHART_TITLE,
    SEGREGATION_OPTIONS,
    GROUPING_OPTIONS,
  } from "$utils/constants.js";
  import { BasicDropdown } from "@urbaninstitute/dataviz-components";
  import { useData } from "$utils/data.svelte.js";
  import RightChart from "./RightChart.svelte";
  import InfoIcon from "./InfoIcon.svelte";
  import {
    MAGNET_SCHOOLS_INFO,
    SPECIALIZED_SCHOOLS_INFO,
    TRANSPORTATION_INFO_3,
    STATE_POLICIES_INFO,
    STATE_POLICY_INTER_LOOKUP,
    STATE_POLICY_INTRA_LOOKUP
  } from "$utils/constants.js";

  import { getTier } from "$utils/tier.svelte.js";

  let toolData = useData();

  let viewportWidth = $state(0);
  let segregationDropdownWidth = $derived(getTier(viewportWidth) === "mobile" ? 220 : 298);

</script>
<svelte:window bind:innerWidth={viewportWidth} />

<div class="right-side-page-layout">
  <div class="district-info-box">
    <div class="left-info">
      <h5 class="district-header">
        #{toolData.activeDistrictData?.EnrollmentRank}
        {toolData.activeDistrictData?.DistrictName}
      </h5>
    </div>
    <div class="right-info">
      <p class="district-info">
        <span class="state-label">{toolData.activeDistrictData?.State}</span>
      </p>
      <p class="district-info">
        Students <span class="grey-highlight">{Number(toolData.activeDistrictData?.EnrollmentFall2023).toLocaleString('en-US')}</span>
      </p>
      <p class="district-info">
        No. of Schools <span class="grey-highlight"
          >{toolData.activeDistrictData?.NumberofSchools}</span
        >
      </p>
      <p class="district-info">
        Enrollment <span class="grey-highlight"
          >{toolData.activeDistrictData?.EnrollmentTrend == 1
            ? "Declining"
            : toolData.activeDistrictData?.EnrollmentTrend == 2
              ? "Growing"
              : "Stable"}</span
        >
      </p>
    </div>
  </div>

  <h6>{RIGHT_DISTRICT_POLICIES_TITLE}</h6>

  <div class="district-instructions">
    <p class="district-instructions-text">
      {RIGHT_DISTRICT_INSTRUCTIONS.split("[XX]").join(toolData.activeDistrictData?.DistrictName)}
    </p>
  </div>

  <div class="policies-box">
    <div class="district-policies-list">
      <p class="policies-header">District</p>
      <p class="policy-item">
        <span class="gray-highlight-yes-no">{toolData.activeDistrictData?.HasCharterSchools == "2" ? "Yes" : "No"}</span>
        <span class="policy-text">Allows charter schools</span>
      </p>
      <p class="policy-item">
          <span class="gray-highlight-yes-no">{toolData.activeDistrictData?.HasMagnetSchools == "2" ? "Yes" : "No"}</span>
        <span class="policy-text">Allows magnet schools <InfoIcon text={MAGNET_SCHOOLS_INFO} nudge={-1} /></span>
      </p>
      <p class="policy-item">
        <span class="gray-highlight-yes-no">{toolData.activeDistrictData?.HasSpecializedSchools == "2" ? "Yes" : "No"}</span>
        <span class="policy-text">Allows specialized schools <InfoIcon text={SPECIALIZED_SCHOOLS_INFO} nudge={-1} /></span>
      </p>
      <p class="policy-item">
        <span class="gray-highlight-yes-no">
          {toolData.activeDistrictData?.TransporttoChoice == "4" ? "Yes" :
           toolData.activeDistrictData?.TransporttoChoice == "1" ? "Yes" :
           toolData.activeDistrictData?.TransporttoChoice == "2" ? "No" : "--"}
        </span>
        <span class="policy-text">
          {toolData.activeDistrictData?.TransporttoChoice == "4" ? "Transportation to choice" :
           toolData.activeDistrictData?.TransporttoChoice == "1" ? "Limited transportation to choice" :
           toolData.activeDistrictData?.TransporttoChoice == "2" ? "Transportation to choice" :
           "Transportation policy unknown"}
          {#if toolData.activeDistrictData?.TransporttoChoice == "3"}<InfoIcon text={TRANSPORTATION_INFO_3} nudge={-1} />{/if}
        </span>
      </p>
    </div>
    <div class="state-policies-list">
      <p class="policies-header">State <span class="header-icon"><InfoIcon text={STATE_POLICIES_INFO} nudge={-3.5} /></span></p>
      {#each [
        { key: "StatePolicyInter", lookup: STATE_POLICY_INTER_LOOKUP },
        { key: "StatePolicyIntra", lookup: STATE_POLICY_INTRA_LOOKUP }
      ] as { key, lookup }}
        {@const val = toolData.activeDistrictData?.[key]}
        {@const entry = lookup[val]}
        {#if entry}
          <p class="policy-item">
            <span class="gray-highlight-yes-no">{entry.yes ? "Yes" : "No"}</span>
            <span class="policy-text">{entry.label}</span>
          </p>
        {/if}
      {/each}
    </div>
  </div>

  <div class="bottom-chart-wrap">
    <h6>{RIGHT_CHART_TITLE}</h6>

    <div class="ux-bar">
      <BasicDropdown
        id="right-boundary-strength-segregation"
        inlineLabel="Select a segregation metric"
        placeholder={null}
        data={SEGREGATION_OPTIONS}
        bind:value={toolData.activeSegregationMetric}
        dropdownWidth={segregationDropdownWidth}
      />
      <BasicDropdown
        id="right-color-grouping"
        inlineLabel="Select a grouping"
        placeholder="Group by..."
        data={GROUPING_OPTIONS.map(({ label, value }) => ({ label, value }))}
        bind:value={toolData.activeRightChartGrouping}
        dropdownWidth={137}
      />
    </div>

    <RightChart />
  </div>
</div>

<style>
  .right-side-page-layout {
    min-height: auto;
    display: flex;
    flex-direction: column;
  }
  @media (min-width: 1160px) {
    .right-side-page-layout {
      min-height: 100%;
    }
  }

  .bottom-chart-wrap {
    margin-top: 24px;
  }
  @media (min-width: 1160px) {
    .bottom-chart-wrap {
      margin-top: auto;
    }
  }

  .ux-bar {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
    margin-bottom: 12px;
    flex-wrap: wrap;
    gap: 9px;
  }
  @media (min-width: 800px) {
    .ux-bar {
      flex-wrap: nowrap;
    }
  }
  .ux-bar > :global(*) {
    flex-shrink: 0;
  }
  /* Segregation dropdown grows to fill the free space, keeping the 9px gap to the grouping dropdown */
  .ux-bar > :global(.dropdown-parent:first-child) {
    flex: 1 1 auto;
    min-width: 0;
  }
  .ux-bar > :global(.dropdown-parent:first-child) :global(.dropdown-container) {
    width: auto !important;
  }
  .district-info-box {
    display: flex;
    gap: 32px;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    background-color: rgba(255, 255, 255, 0.72);
    padding: 15px 20px 15px 20px;
    margin-bottom: 36px;
  }
  .left-info h5.district-header {
    font-size: var(--font-size-2xl);
    color: var(--color-gray-shade-darkest);
    margin: 0;
  }
  .right-info {
    flex-shrink: 0;
    p.district-info {
      font-size: var(--font-size-small);
      margin: 7px 0;
      padding: 0;
      text-align: right;
      line-height: var(--line-height-snug);
    }
    span.state-label {
      color: white;
      font-weight: var(--font-weight-bold);
      background-color: var(--color-blue);
      padding: 3px 5px;
      letter-spacing: 1.4px;
      font-family: var(--font-family-sans-alt);
    }
  }
  @media (max-width: 799px) {
    .district-info-box {
      flex-direction: column;
      gap: 4px;
      align-items: flex-start;
    }
    .right-info {
      p.district-info {
        text-align: left;
      }
    }
  }



  .policies-box {
    p.policy-item {
      font-size: var(--font-size-small);
      margin: 7px 0;
      padding: 0;
      line-height: var(--line-height-snug);
      display: flex;
      align-items: baseline;
      gap: 5px;
    }
    span.policy-text {
      flex: 1;
      min-width: 0;
    }
  }
  span.grey-highlight {
    font-weight: bold;
    background-color: #ECECEC;
    padding: 3px 4px;
  }
  span.gray-highlight-yes-no {
    font-weight: bold;
    background-color: #ECECEC;
    padding: 0;
    display: inline-block;
    width: 1.75rem;
    text-align: center;
  }
  .district-instructions {
    background-color: rgba(255, 255, 255, 0.72);
    padding: 5px 16px;
    margin-top: 8px;
    margin-bottom: 8px;
    p.district-instructions-text {
      font-size: var(--font-size-small);
      line-height: 150%;
    }
  }
  .policies-box {
    background-color: rgba(255, 255, 255, 0.72);
    padding: 11px 21px;
    margin-bottom: 33px;
    display: flex;
    gap: 10px;
    justify-content: space-between;
  }
  @media (max-width: 799px) {
    .policies-box {
      flex-direction: column;
      gap: 16px;
    }
  }
  .policies-box p.policies-header {
    font-family: var(--font-family-sans-alt);
    font-size: 14px;
    font-weight: var(--font-weight-bold);
    letter-spacing: 1.4px;
    text-transform: uppercase;
  }
  .district-policies-list {
    flex: 3;
  }
  .state-policies-list {
    flex: 2;
  }
  @media (min-width: 800px) {
    .state-policies-list {
      padding-left: 14px;
    }
  }
  .header-icon {
    font-family: var(--font-sans);
    font-size: var(--font-size-small);
    font-weight: normal;
    letter-spacing: normal;
    text-transform: none;
    vertical-align: middle;
  }

</style>
